import { render, staticRenderFns } from "./Renderer.vue?vue&type=template&id=4be0b8c6&scoped=true"
import script from "./Renderer.vue?vue&type=script&lang=js"
export * from "./Renderer.vue?vue&type=script&lang=js"
import style0 from "./Renderer.vue?vue&type=style&index=0&id=4be0b8c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be0b8c6",
  null
  
)

export default component.exports